import { NavigationItem } from '@markant-platform/shared/navigation/model';

function createNavItem(label: string, route: string, image = '', isTitle = false): NavigationItem {
  return {
    label,
    route,
    image,
    isCollapsed: true,
    children: [],
    isActive: false,
    isTitle,
  };
}

export const NAVIGATION_PFA_ITEMS = [
  createNavItem('platformAdministration', '', '', true),
  createNavItem('organizationOverview', '/backoffice/organizations'),
  createNavItem('roleOverview', '/backoffice/role-overview'),
  createNavItem('userOverview', '/backoffice/users'),
  createNavItem('cartridges', '/backoffice/cartridges'),
  createNavItem('platformNotifications', '/backoffice/platform-notifications'),
  createNavItem('existingCustomerRegistration', '/backoffice/existing-customer-registration'),
  createNavItem('platformRequests', '/backoffice/platform-requests-audit'),
  createNavItem('serviceAdministration', '/backoffice/service-management'),
];

export const NAVIGATION_OA_ITEMS = [
  createNavItem('%organization%', '', '', true),
  createNavItem('organizationDetailsOverview', '/organization/organization-overview'),
  createNavItem('bookedServices', '/organization/booked-cartridges'),
  createNavItem('memberOverview', '/organization/members'),
  createNavItem('groupAssignment', '/organization/group-assignment'),
];

export const NAVIGATION_SA_ITEMS = [
  createNavItem('serviceManagement', '', '', true),
  createNavItem('serviceDocumentsOverview', '/cartridge-admin/cartridge-services'),
  createNavItem('serviceNotifications', '/cartridge-admin/cartridge-notifications'),
  createNavItem('variantsOverview', '/cartridge-admin/variants'),
  createNavItem('bookingRequests', '/cartridge-admin/booking-requests'),
  createNavItem('contactRequests', '/cartridge-admin/contact-requests'),
  createNavItem('priceRequests', '/cartridge-admin/price-requests/service-administrator'),
  createNavItem('serviceAdministration', '/cartridge-admin/service-management'),
];

export const NAVIGATION_USER = [createNavItem('dashboard', '/', 'dashboard')];
